export default (uuid: string): void => {
  if (window.PGWidgets && window.PGWidgets.renderMagicLink) {
    window.PGWidgets.renderMagicLink('magic-link', uuid);
  }
};
